
import { defineComponent } from 'vue';
import Form from '@/shared/mixins/Form';
import { required, email } from '@vuelidate/validators';
import { estateAgentReviewService } from '@/estate-agent-review/EstateAgentReviewService';
import EstateAgentReviewStars from './EstateAgentReviewStars.vue';
import useVuelidate from '@vuelidate/core';

export default defineComponent({
  name: 'EstateAgentReviewRequestForm',
  mixins: [Form],
  setup() {
    return { v$: useVuelidate({ $scope: false }) };
  },
  components: {
    EstateAgentReviewStars,
  },
  props: {
    adId: { type: Number, required: true },
    hasReview: { type: Boolean, required: true },
  },
  data() {
    return {
      isInitializing: true,
      review: null as null | any,
      form: {
        adId: null as null | number,
        email: null,
      },
    };
  },
  validations() {
    return {
      form: {
        email: { required, email },
      },
    };
  },
  async created() {
    this.isLoading = true;
    try {
      if (this.hasReview) {
        const result = await estateAgentReviewService.getById(this.adId);
        if (result.status === 200) {
          this.review = result.data;
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.isLoading = false;
      this.isInitializing = false;
    }
  },
  methods: {
    async send() {
      if (!this.validate()) {
        return;
      }

      this.isLoading = true;
      try {
        this.form.adId = this.adId;
        await estateAgentReviewService.request(this.form);
        this.success();
      } catch (error) {
        this.handleApiError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async publishReview() {
      this.isLoading = true;
      try {
        const response = await estateAgentReviewService.publish({ estateAgentReviewId: this.review.estateAgentReviewId });
        if (response.status === 200) {
          this.review.isPublished = true;
        }
      } catch (error) {
        this.handleApiError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async deleteReview() {
      this.isLoading = true;
      try {
        const response = await estateAgentReviewService.delete(this.review.estateAgentReviewId);
        if (response.status === 200) {
          this.review = null;
        }
      } catch (error) {
        this.handleApiError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
});
